import constants, { ACCESS_TOKEN, HTTP_METHODS, SIGNIN_AUTH_TOKEN } from "../../../settings/shared/constants"
import axiosClient from "../../common"
/**
 * This function helps to authenticate with backend and 
 * returns its response.
 * 
 * @param {*} user {email, password, tenant}
 */
function _constructHeader() {
    let headers = {
        'Content-Type': 'application/json'
    }
    return headers;
}

function auth(email, recaptchaToken) {
    return axiosClient({
        url: constants.api.auth.login + '?email=' + email + '&recaptchaToken=' + recaptchaToken,
        method: HTTP_METHODS.POST,
        headers: _constructHeader()
    })
}

function loginWithPassword(user, recaptchaToken = null) {
    if (recaptchaToken) user.recaptchaToken = recaptchaToken;
    return axiosClient({
        url: constants.api.auth.passwordLogin,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: user
    })
}

function validateAuth(data) {
    let headers = _constructHeader();
    headers["Authorization"] = "Bearer " + sessionStorage.getItem(SIGNIN_AUTH_TOKEN);
    return axiosClient({
        url: constants.api.auth.validateAuth,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: data
    })
}

function verifyOTP(data) {
    let headers = _constructHeader();
    headers["Authorization"] = "Bearer " + sessionStorage.getItem(SIGNIN_AUTH_TOKEN);
    return axiosClient({
        url: constants.api.auth.verifyOTP,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: data
    })
}

function oauth2Callback(data) {
    let headers = _constructHeader();
    return axiosClient({
        url: constants.api.auth.oauth2Callback,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: data
    })
}

function loginVerify(email, recaptchaToken) {
    return axiosClient({
        url: constants.api.auth.loginVerify + '?email=' + email + '&recaptchaToken=' + recaptchaToken,
        method: HTTP_METHODS.POST,
        headers: _constructHeader()
    })
}

function switchTenant(tenantName, email) {
    let headers = _constructHeader();
    headers["Authorization"] = "Bearer " + localStorage.getItem(ACCESS_TOKEN);
    return axiosClient({
        url: constants.api.auth.switchTenant + '?tenantName=' + tenantName + '&email=' + email,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: {}
    })
}

function authorizeDesktop({
    clientId,
    redirectUri,
    codeChallenge,
    codeChallengeMethod,
    state,
    scope,
    accessToken,
}) {
    let headers = _constructHeader();
    headers["Authorization"] = "Bearer " + (accessToken || localStorage.getItem(ACCESS_TOKEN));
    return axiosClient({
        url: constants.api.auth.desktopAuthorize,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: {
            client_id: clientId,
            redirect_uri: redirectUri,
            code_challenge: codeChallenge,
            code_challenge_method: codeChallengeMethod || "S256",
            state,
            scope,
        },
    });
}

const LoginService = {
    auth, loginWithPassword, validateAuth, verifyOTP, oauth2Callback, loginVerify, switchTenant, authorizeDesktop
}

export default LoginService;
